import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _getReferenceNumberLa;
import _get from 'lodash/get';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { ENTITY_REFERENCE_TYPES } from '@tekion/tekion-base/constants/parts/entityReferenceTypes';
import { getSorReferenceNumber } from '@tekion/tekion-base/helpers/parts/sor/sor.helper';
var getReferenceNumberLabel = (_getReferenceNumberLa = {}, _defineProperty(_getReferenceNumberLa, ENTITY_REFERENCE_TYPES.CUSTOMER, function (sorDetails) {
  return "SOR ".concat(_get(sorDetails, 'sorNumber', ''), " - Cust: ").concat(getSorReferenceNumber(sorDetails));
}), _defineProperty(_getReferenceNumberLa, ENTITY_REFERENCE_TYPES.SALES_ORDER, function (sorDetails) {
  return "SOR ".concat(_get(sorDetails, 'sorNumber', ''), " - SO: ").concat(getSorReferenceNumber(sorDetails));
}), _defineProperty(_getReferenceNumberLa, ENTITY_REFERENCE_TYPES.FULFILMENT, function (sorDetails) {
  return "SOR ".concat(_get(sorDetails, 'sorNumber', ''), " - RO: ").concat(getSorReferenceNumber(sorDetails));
}), _getReferenceNumberLa);
var getOptionValue = function getOptionValue() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  return _get(option, 'data.id');
};
var getOptionLabel = function getOptionLabel() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var sor = _get(option, 'data', EMPTY_OBJECT);
  var refType = sor.refType;
  return getReferenceNumberLabel[refType] ? getReferenceNumberLabel[refType](sor) : '';
};
var SOR_CONFIG = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue
};
export default SOR_CONFIG;